import React from 'react';
import { motion } from 'framer-motion';
import { goToCheckout } from '../utils/checkout';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-lg transition-colors duration-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy';
  const variants = {
    primary: 'bg-navy text-white hover:bg-navy-light',
    secondary: 'bg-mint text-navy hover:bg-mint-dark'
  };
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      goToCheckout();
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={handleClick} {...props} data-id="element-30">
      {children}
    </motion.button>;
}